import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { PersonOutlineOutlined, ExitToAppOutlined } from "@material-ui/icons";
import { useStyles } from "./../styles";
import { get } from "lodash";
import LoadingWidget from "../../widgets/LoadingWidget";
import { useTranslation } from "react-i18next";
// import { useRecoilValue } from "recoil";
// import { CompanyDetails } from "../../../recoil/LoggedInUserDetail/selector";
import HeaderNotificationsSection from "../Header/HeaderNotificationsSection";
const MobileMenu = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  // const companyDetail = useRecoilValue(CompanyDetails);
  const isMobileMenuOpen = Boolean(props.mobileMoreAnchorEl);
  return (
    <Menu
      anchorEl={props.mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={props.mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={props.handleMobileMenuClose}
      className={classes.headerNotifList}
      getContentAnchorEl={null}
    >
      {props.isCompanySetupCompleted && (
        <>
          <HeaderNotificationsSection isMobile={true} />
          <span className={classes.mobileMenuDivider}></span>
          <MenuItem onClick={props.handleProfile}>
            <PersonOutlineOutlined
              className={classes.mobileMenuIcon}
              onClick={props.handleProfileMenuOpen}
            />
            <p className={classes.mobileMenuName}>{t("layout.myProfile")}</p>
          </MenuItem>
          <MenuItem onClick={props.handleLogout}>
            {get(props, "logOutLoading", "") ? (
              <LoadingWidget color="grey" />
            ) : (
              <ExitToAppOutlined className={classes.mobileMenuIcon} />
            )}
            <p className={classes.mobileMenuName}>{t("layout.logout")}</p>
          </MenuItem>
        </>
      )}
    </Menu>
  );
};

export default MobileMenu;
